export default __webpack_public_path__ + "static/media/Activity16.662645c1.jpeg";